import { render } from "./nodata.vue?vue&type=template&id=2f0c719c"
import script from "./nodata.vue?vue&type=script&lang=js"
export * from "./nodata.vue?vue&type=script&lang=js"

import "./nodata.vue?vue&type=style&index=0&id=2f0c719c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__